import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Input } from 'antd'
import { computed } from 'mobx'
import { OFTableController } from '../OFTableController'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

@inject('OFTableController')
@observer
export class Pagination extends Component<
  {
    OFTableController?: OFTableController
  }
> {
  private inputRef = null

  @computed get getPages() {
    const { pagination } = this.props.OFTableController.props

    return Math.ceil(pagination.total / pagination.perPage)
  }

  private handleInputChange = (value, arrowClick = true) => {
    const { pagination } = this.props.OFTableController.props

    const reg = /^-?[0-9]*(\.[0-9]*)?$/

    if (!value) {
      pagination.pageChange(1, arrowClick)

      return
    }

    if (!isNaN(value) && reg.test(value) && value > 0 && value <= this.getPages) {
      pagination.pageChange(Number(value), arrowClick)

      // Remove focus from the input if it was passed via on enter
      arrowClick && this.inputRef.blur()
    }
  }

  public render() {
    const { pagination, loading } = this.props.OFTableController.props

    return (
      <div className='flex'>
        <Button
          disabled={pagination.currentPage === 1 || pagination.disabled || loading}
          onClick={() => this.handleInputChange(pagination.currentPage - 1)}
          size={pagination.size || 'small'}
          icon={<FontAwesomeIcon icon={faAngleLeft}/>}
          className='mr-3'
          style={{ minWidth: 24 }}
        />

        <Input
          style={{ width: 100, textAlign: 'center', minWidth: 60 }}
          size={pagination.size || 'small'}
          value={pagination.currentPage}
          addonAfter={this.getPages}
          onChange={(e) => this.handleInputChange(e.target.value, false)}
          onPressEnter={(e) => this.handleInputChange(e.currentTarget.value)}
          disabled={pagination.disabled || loading}
          ref={(ref) => (this.inputRef = ref)}
        />

        <Button
          onClick={() => this.handleInputChange(pagination.currentPage + 1)}
          disabled={pagination.currentPage === this.getPages || pagination.disabled || loading}
          size={pagination.size || 'small'}
          icon={<FontAwesomeIcon icon={faAngleRight}/>}
          className='ml-3 mr-3'
          style={{ minWidth: 24 }}
        />
      </div>
    )
  }
}
